/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CustomDataDisplay} from "../../../models/custom-data-display.model";

@Component({
    selector: 'app-selector-pop-up',
    templateUrl: './selector-pop-up.component.html',
    styleUrl: './selector-pop-up.component.scss',
    standalone: false
})
export class SelectorPopUpComponent {

  isMultiSelect: boolean;
  customDataDisplay: CustomDataDisplay[];
  headerText: string;

  selectedOptions: any[];

  constructor(private readonly dialogRef: MatDialogRef<SelectorPopUpComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    this.customDataDisplay = data.customDataDisplay;
    this.headerText = data.headerText;
    if (this.data.isMultiSelect !== undefined) {
      this.isMultiSelect = data.isMultiSelect;
    }
  }

  /**
   * If a user cancels the selection, exit the dialog.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * On confirmation, return the selected options.
   */
  onConfirm(): void {
    this.dialogRef.close(this.selectedOptions);
  }

  /**
   * selects everything in the list
   */
  onSelectAll() {
    this.selectedOptions = this.customDataDisplay.map(element => element.data);
  }
}
